import AppIcon from "@/components/AppIcon";
export default {
  name: "SeoParentVariationTheme",
  components: {
    AppIcon
  },
  props: {
    theme: String,
    showIcon: Boolean
  }
};